import React from "react";
import { Route, Routes } from "react-router-dom";
import { CustomerProvider } from "../context/customer/customerContext";
import Introduction from "../pages/Customer/Introduction";
import CustomerDetails from "../pages/Customer/Confirmation/CustomerDetails";
import Error from "../pages/Customer/Confirmation/ProblemTitle";
import Identity from "../pages/Customer/Confirmation/Identity";
import {Inspection, Delivery, EstimatedCharge} from "../pages/Customer/TurnIn";
import TurnInStatus from "../pages/Customer/TurnInStatus";

/**
 * Defines routes specific to customer interactions within the application.
 *
 * This function component wraps several route definitions using React Router's `Route` component,
 * each associated with different customer-related functionalities. It is encapsulated within a `CustomerProvider`
 * to ensure that all nested components have access to customer-related context.
 * @returns {React.ReactElement} A JSX fragment containing route definitions for customer confirmation, item turn-in,
 * and turn-in status views, all within a customer context provider.
 */
function CustomerRoutes() {
  return (
    <CustomerProvider>
      <Routes>
        <Route path="/identity" element={<Identity />} />
        <Route path="/details" element={<CustomerDetails />} />
        <Route path="/error/:errorType" element={<Error />} />
        <Route path="/introduction" element={<Introduction />} />
        <Route path="/condition" element={<Inspection />} />
        <Route path="/delivery" element={<Delivery />} />
        <Route path="/estimate" element={<EstimatedCharge />} />
        <Route path="/status" element={<TurnInStatus />} />
      </Routes>
    </CustomerProvider>
  );
}

export default CustomerRoutes;
